import DOMPurify from "dompurify";

const BASE_TAGS = [
  "p",
  "br",
  "hr",
  "strong",
  "em",
  "u",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "ul",
  "ol",
  "li",
  "a",
  "img",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "div",
  "span",
  "center",
  "blockquote",
  "pre",
  "code"
];

const DOCUMENT_ATTRS = ["charset", "content", "name", "media", "lang", "dir"];

const BASE_ATTRS = [
  "href",
  "src",
  "alt",
  "title",
  "style",
  "class",
  "target",
  "rel",
  "width",
  "height",
  "align",
  "valign",
  "bgcolor",
  "cellpadding",
  "cellspacing",
  "border"
];

/**
 * Same allowlist for a whole email document: keeps `html`/`head`/`body` and
 * the editor's `<style>` (its responsive @media rules live there).
 * Script/handler stripping is unchanged.
 */
export const sanitizeEmailDocument = (html: string) =>
  DOMPurify.sanitize(html, {
    WHOLE_DOCUMENT: true,
    ADD_TAGS: ["html", "head", "body", "style", "meta", "title"],
    ADD_ATTR: DOCUMENT_ATTRS,
    ALLOWED_TAGS: [
      "html",
      "head",
      "body",
      "style",
      "meta",
      "title",
      ...BASE_TAGS
    ],
    ALLOWED_ATTR: [...DOCUMENT_ATTRS, ...BASE_ATTRS],
    ALLOW_DATA_ATTR: false
  });

/**
 * Sanitizes an email body fragment using a strict tag/attribute allowlist,
 * shared by every surface that shows one. The allowlist keeps presentational
 * markup (hr, center, table sizing attributes) — email lays itself out with
 * those rather than with stylesheets, so dropping them collapses the design.
 */
export const sanitizeEmailHtml = (html: string) =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: BASE_TAGS,
    ALLOWED_ATTR: BASE_ATTRS,
    ALLOW_DATA_ATTR: false
  });
